import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["className", "tabsContent", "tabsId", "initialSelectedIndex", "isVerticalView", "tabWrapClassName", "panelWrapClassName", "onTabChange"];
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Tabs
 */
import React, { Component } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import styles from './Tabs.style';
import Tab from './Tab';
import TabPanel from './TabPanel';
import List from '../../molecules/List';
import Para from '../../atoms/Para';
var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);
  var _super = _createSuper(Tabs);
  function Tabs() {
    var _this;
    _classCallCheck(this, Tabs);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedIndex: _this.setDefaultActiveTab()
    });
    _defineProperty(_assertThisInitialized(_this), "updateTabChange", function (index) {
      var onTabChange = _this.props.onTabChange;
      _this.setState({
        selectedIndex: index
      });
      if (onTabChange) {
        onTabChange(index);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "tabClick", function (e, index) {
      e.preventDefault();
      var selectedIndex = _this.state.selectedIndex;
      if (selectedIndex === index) {
        return;
      }
      _this.updateTabChange(index);
    });
    return _this;
  }
  _createClass(Tabs, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
        selectedIndex = _this$props.selectedIndex,
        activeTab = _this$props.activeTab;
      if (this.state.selectedIndex !== selectedIndex && activeTab) {
        this.setState({
          selectedIndex: selectedIndex
        });
      }
    }
  }, {
    key: "setDefaultActiveTab",
    value: function setDefaultActiveTab() {
      var initialSelectedIndex = this.props.initialSelectedIndex;
      return initialSelectedIndex || 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        className = _this$props2.className,
        tabsContent = _this$props2.tabsContent,
        tabsId = _this$props2.tabsId,
        initialSelectedIndex = _this$props2.initialSelectedIndex,
        isVerticalView = _this$props2.isVerticalView,
        tabWrapClassName = _this$props2.tabWrapClassName,
        panelWrapClassName = _this$props2.panelWrapClassName,
        onTabChange = _this$props2.onTabChange,
        others = _objectWithoutProperties(_this$props2, _excluded);
      var selectedIndex = this.state.selectedIndex;
      var listOptions = {
        noDefaultView: true,
        inline: !isVerticalView,
        noMargin: true
      };
      return __jsx("div", _extends({
        id: tabsId,
        className: classNames({
          row: isVerticalView
        }, className)
      }, others), __jsx("div", {
        className: classNames('tabs-wrap', tabWrapClassName)
      }, __jsx(List, _extends({
        role: "tablist"
      }, listOptions, {
        className: "nva-tabs"
      }), tabsContent && tabsContent.map(function (item, index) {
        return __jsx(Tab, {
          className: "nva-tabs__tab ".concat(item.tabClassName || ''),
          index: index,
          isSelected: index === selectedIndex,
          onClick: _this2.tabClick,
          tabId: "tab-list-item-".concat(index),
          key: "tab-".concat(index.toString()),
          anchorTitle: item.tabTitle
        }, __jsx(Para, {
          className: "nva-tabs__tab-heading heading_five"
        }, item.tabTitle));
      }))), __jsx("div", {
        className: classNames('panels-wrap', panelWrapClassName)
      }, tabsContent && tabsContent.map(function (item, index) {
        return __jsx(TabPanel, {
          className: "nva-tabs__tab-panel ".concat(item.panelClassName || ''),
          isSelected: index === selectedIndex,
          tabId: "tab-list-item-".concat(index),
          index: index,
          key: "tab-panel-".concat(index.toString())
        }, item.panelContent);
      })));
    }
  }]);
  return Tabs;
}(Component);
_defineProperty(Tabs, "defaultProps", {
  className: '',
  tabsId: '',
  initialSelectedIndex: 0,
  selectedIndex: 0,
  isVerticalView: false,
  tabWrapClassName: '',
  panelWrapClassName: ''
});
export default styled(Tabs).withConfig({
  componentId: "sc-ykh7ny-0"
})(["", ";"], styles);
export { Tabs as TabsVanilla };